import { render } from "./ReadEmailPage.vue?vue&type=template&id=30b7a1a0&ts=true"
import script from "./ReadEmailPage.vue?vue&type=script&lang=ts"
export * from "./ReadEmailPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__